module.exports = __webpack_public_path__ + "img/suspicious_activity.9ec5b719.jpg";